"use strict";

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var days = [1, 2, 3, 4, 5, 6, 0]; // ISO Weekdays

var useTimeTables = function useTimeTables(timeTables) {
  var hourlyCycle = (0, _react.useMemo)(function () {
    if (!timeTables) {
      return days.map(function (day) {
        return {
          day: day
        };
      });
    }

    return days.map(function (day) {
      var timeTable = timeTables.find(function (table) {
        return (table === null || table === void 0 ? void 0 : table.day) === day;
      });

      if (!timeTable) {
        return {
          day: day
        };
      }

      return {
        day: day,
        ranges: timeTable.ranges
      };
    });
  }, [timeTables]);
  return hourlyCycle;
};

__signature__(useTimeTables, "useMemo{hourlyCycle}");

var _default = useTimeTables;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(days, "days", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Hours/HourlyCycle/useTimeTables.ts");
  reactHotLoader.register(useTimeTables, "useTimeTables", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Hours/HourlyCycle/useTimeTables.ts");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Hours/HourlyCycle/useTimeTables.ts");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();